export default function BrainrotHeistIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="2" y="26" width="60" height="14" fill="#2a8f9a" />
      <rect x="2" y="24" width="60" height="3" fill="#5d6b7a" />
      <rect x="2" y="39" width="60" height="3" fill="#5d6b7a" />
      <path
        d="M22 50c-10 0-12-12-6-20 4-6 14-8 18-2 6 8 4 22-12 22z"
        fill="#7bd65a"
        stroke="#2f7a2a"
        strokeWidth="3"
      />
      <circle
        cx="21"
        cy="33"
        r="5"
        fill="#fff"
        stroke="#000"
        strokeWidth="1.5"
      />
      <circle
        cx="31"
        cy="33"
        r="5"
        fill="#fff"
        stroke="#000"
        strokeWidth="1.5"
      />
      <circle cx="22.5" cy="34" r="2.2" fill="#000" />
      <circle cx="29.5" cy="32" r="2.2" fill="#000" />
      <path
        d="M20 42q6 4 12 0"
        stroke="#000"
        strokeWidth="2.5"
        fill="none"
        strokeLinecap="round"
      />
      <path d="M16 24h20l-2-10H18z" fill="#2a2a3a" />
      <rect x="13" y="22" width="26" height="4" rx="2" fill="#2a2a3a" />
      <circle
        cx="50"
        cy="16"
        r="10"
        fill="#ffd84d"
        stroke="#c99200"
        strokeWidth="2.5"
      />
      <text
        x="50"
        y="21"
        textAnchor="middle"
        fontSize="13"
        fontWeight="900"
        fill="#7a5600"
        fontFamily="system-ui, sans-serif"
      >
        $
      </text>
      <path
        d="M44 54l6-6 6 6M50 48v12"
        stroke="#ff5a5a"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}
